module.exports = __webpack_public_path__ + "img/ma.39e4875a.svg";